export const LocalStorageKeys = {
	SHOW_BACKGROUND_MODE_MODAL: '@showBackgroundModeModal',
	REGISTER_CONTRACTS: '@registerContracts',
	ACTIVE_QUESTION_TIMER: '@activeQuestionTimer',
	SOLVER_TIMERS: 'solver_timers',
	MEET_PROVIDER_TEST_SNOOZED_AT: '@meetProviderTestSnoozedAt',
	APPEARANCE: '@appearance'
};
